import { render, staticRenderFns } from "./GoogleProfileVertical.vue?vue&type=template&id=3797046e&scoped=true&"
import script from "./GoogleProfileVertical.vue?vue&type=script&lang=js&"
export * from "./GoogleProfileVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3797046e",
  null
  
)

export default component.exports